import { LoadingStatusEnum } from "etl/types";

export interface FormStepData {
	// common
	importLoadingStatus: LoadingStatusEnum;
	// import
	validatingSelectImportStep: number;
	// user
	isRefreshingUser: boolean;
	// brand
	isRefreshingBrand: boolean;
	// product
	isRefreshingProduct: boolean,
	// laboratory
	isRefreshingLaboratory: boolean,
	// supplier
	isRefreshingSupplier: boolean
	// category
	isRefreshingCategory: boolean
	// schedule type
	isRefreshingScheduleType: boolean;
	// product
	dictionnaryProductTriggered: boolean
	// laboratory
	dictionnaryLaboratoryTriggered: boolean
	// output file generation
	outputGenerationTriggered: boolean
	// uploading file
	uploadingFile: { labId: number, fileName: string }[]
	// preprocessing
	unzipRunning: boolean
	preProcessRunning: boolean
	inspectProcessFileRunning: boolean
	listeningToMinificationEnding: boolean
	listeningToUploadS3BucketEnding: boolean
	uploadingS3Bucket: "pdf" | "csv" | null
	awInsertRunning: boolean
	// import PDF
	importPdfRunning: boolean

	correctingCSvLineManually: boolean
	reuploadingCsv: boolean
}

export const formStepReducerInit = (): FormStepData => {
	return {
		// common
		importLoadingStatus: LoadingStatusEnum.NotLoaded,
		// import
		validatingSelectImportStep: 0,
		// user
		isRefreshingUser: false,
		// brand
		isRefreshingBrand: false,
		// product
		isRefreshingProduct: false,
		// laboratory
		isRefreshingLaboratory: false,
		// supplier
		isRefreshingSupplier: false,
		// category
		isRefreshingCategory: false,
		// schedule type
		isRefreshingScheduleType: false,
		// product
		dictionnaryProductTriggered: false,
		// laboratory
		dictionnaryLaboratoryTriggered: false,
		// output file generation
		outputGenerationTriggered: false,
		// uploading file
		uploadingFile: [],
		// preprocessing
		unzipRunning: false,
		preProcessRunning: false,
		inspectProcessFileRunning: false,
		listeningToMinificationEnding: false,
		listeningToUploadS3BucketEnding: false,
		uploadingS3Bucket: null,
		awInsertRunning: false,
		// import PDF
		importPdfRunning: false,
		// correcting CSV line manually
		correctingCSvLineManually: false,
		reuploadingCsv: false
	}
};
